import axios from "axios";
import { ResponseMessage } from "../models/ResponseMessage";
import { Constants } from "../constants/constants";
import {
  PublicBookRequest,
  PublicBookResponse,
  PublicContactRequest,
} from "../models/PublicBookingModels";

const API_BASE_URL = Constants.API_BASE_URL;

// Public endpoints are AllowAnonymous. Use a bare instance (no interceptors,
// no credentials) so no Authorization header or cookie is ever attached.
const publicHttp = axios.create();

export async function submitPublicContactAsync(
  slug: string,
  request: PublicContactRequest,
): Promise<ResponseMessage<boolean>> {
  const response = await publicHttp.post(
    `${API_BASE_URL}/public/organizations/${slug}/contact`,
    request,
  );

  return ResponseMessage.fromJson(response.data);
}

export async function createPublicBookingAsync(
  slug: string,
  request: PublicBookRequest,
): Promise<ResponseMessage<PublicBookResponse>> {
  const response = await publicHttp.post(
    `${API_BASE_URL}/public/organizations/${slug}/book`,
    request,
  );

  return ResponseMessage.fromJson(response.data);
}
